<!-- components/RewardDepositBarChart.vue -->
<template>
   <div class="reward-chart-wrap">
    <!-- 無數據 -->
    <div v-if="!chartData || chartData.length === 0" class="empty-box">
      No Data
    </div>

    <!-- 圖表 -->
    <div
      v-else
      :id="chartId"
      :style="{
        width: width,
        height: height
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "RewardDepositBarChart",

  props: {
    // 圖表數據
    chartData: {
      type: Array,
      default: () => []
    },

    // 圖表寬高
    width: {
      type: String,
      default: "100%"
    },

    height: {
      type: String,
      default: "350px"
    },

    // 唯一ID
    chartId: {
      type: String,
      default: "echartsRewardDeposit"
    }
  },

  data() {
    return {
      chartInstance: null
    };
  },

  watch: {
    chartData: {
      handler(newVal) {
        // 無數據時銷毀圖表
        if (!newVal || newVal.length === 0) {
          if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
          }

          return;
        }

        // 有數據但未初始化
        if (!this.chartInstance) {
          this.$nextTick(() => {
            this.initChart();
          });
        } else {
          this.renderChart();
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    if (this.chartData && this.chartData.length > 0) {
      this.initChart();
    }

    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },

  methods: {
    initChart() {
      const dom = document.getElementById(this.chartId);

      if (!dom) return;

      this.chartInstance = this.$echarts.init(dom);

      this.renderChart();
    },

    renderChart() {
      if (!this.chartInstance) return;

      const xData = this.chartData.map(item => item.date);
      const yData = this.chartData.map(item => item.l_deposit);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },

        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },

        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            lineStyle: {
              color: "#999"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#666",
            rotate: 0
          }
        },

        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#E5E5E5"
            }
          },
          axisLabel: {
            color: "#666"
          }
        },

        series: [
          {
            name: this.$t('RewardCenter.Stistic.modular3.RewardTotal'),
            type: "bar",
            data: yData,

            barWidth: 24,

            itemStyle: {
              color: "#3399FF",
              showBackground: true,
              borderRadius: [10, 10, 10, 10]
            }
          }
        ]
      };

      this.chartInstance.setOption(option);
    },

    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>

<style scoped>
.reward-chart-wrap {
  width: 100%;
}

.empty-box {
  width: 100%;
  height: 350px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #999;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding: 0 20px;
}
</style>